export const SET_TIMER = 'programs::SET_TIMER';
